import { StateVariant } from "@tagged-state/core";
import { createContext, createTaggedStateHook } from "@tagged-state/react";

export type FaceTecDeviceSdkParams = {
  deviceKeyIdentifier: string;
};

export type State =
  | StateVariant<"uninit">
  | StateVariant<"pending">
  | StateVariant<"ready", FaceTecDeviceSdkParams>
  | StateVariant<"error", { error: Error }>;

const { Context, ComponentGuard } = createContext<State>({
  tag: "uninit",
  data: {},
});

export const FaceTecDeviceSdkParamsContext = Context;
export const FaceTecDeviceSdkParamsGuard = ComponentGuard;
export const useFaceTecDeviceSdkParams = createTaggedStateHook(
  Context,
  "ready" as const,
);
